import { Document, User } from "@/models";
import { DocumentStatus } from "../Document";

export default class WorkPlan extends Document {
  static type = "documentWorkPlans";

  static statuses: DocumentStatus = [...Document.statuses];

  statusLabel(user: User) {
    const status = WorkPlan.statuses.find((o) => o.id === this.status);
    return status?.labels[user.role] || status?.labels.default;
  }

  get statusClass() {
    const status = WorkPlan.statuses.find((o) => o.id === this.status);
    return status?.class;
  }

  get initiativeStatus() {
    const withoutSuperClass = WorkPlan.type.replace("document", "");
    return (
      withoutSuperClass.charAt(0).toLocaleLowerCase() +
      withoutSuperClass.slice(1)
    );
  }
}
